// extracted by mini-css-extract-plugin
var _1 = "nzlSN";
var _2 = "zohmR";
var _3 = "uD_Du";
var _4 = "knsqd";
export { _1 as "base", _2 as "content", _3 as "empty", _4 as "error" }
